import { render, staticRenderFns } from "./BigLock.vue?vue&type=template&id=0a8b1a15&scoped=true&"
import script from "./BigLock.vue?vue&type=script&lang=js&"
export * from "./BigLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b1a15",
  null
  
)

export default component.exports